import React, { useState } from "react";

const Modal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        color: "black",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "1000px",
          height: "500px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            textAlign: "left",
            paddingRight: "10px",
          }}
        >
          <p style={{ marginBottom: "15px" }}>
            If you just somehow stumbled upon this, what you're seeing is a
            recreation of the avatar system of now-defunct (as of Dec 31st,
            2025) virtual pet site Goatlings.com
            <br />
            <br /> This page was made to revive a beloved feature that would've
            otherwise died with the site itself. If you have no idea what I'm
            talking about and you're curious about what happened to Goatlings,{" "}
            <a href="https://www.tumblr.com/goatlingsvent/803609307192147968/for-users-who-are-out-of-the-loop-in-regards-to?source=share">
              here
            </a>{" "}
            is a summary.
            <br />
            <br />
            Changelog 12/25/2025:
            <ul>
              <li>
                fixed bug where ID collisions cause some items add themselves
                twice when loading an outfit
              </li>
              <li>
                an important caveat of the outfit archive system that i've
                neglected to make fully clear: it uses your browser's local
                storage, which means that if you clear your cookies, you'll most
                likely lose your outfits!
                <ul>
                  <li>
                    To make this system less dangerous, you can now load an
                    outfit from JSON formatted text, and also export it as such!
                    simply go to the outfit archive, click "load from text",
                    click "save current outfit" and store the text someplace
                    safe. dont worry, the archive system still works! this is
                    just a precaution for outfits you really dont want to risk
                    losing :)
                  </li>
                </ul>
              </li>
            </ul>
            <br />
            Changelog 12/24/2025:
            <ul>
              <li>
                Added missing items from the past few weeks. apparently i lied
                last changelog and forgot to add them LOL sorry
              </li>
              <li>
                themes! please note that the backgrounds of items have been left
                white to aid visual clarity. items were made to be displayed on
                a white background, so a lot of them become near invisible on
                dark backgrounds!
              </li>

              <li>
                some slight UI polish. sorry mobile users, i tried my best with
                the title header, i hope its not too bad!
              </li>
              <li>added this site summary</li>
              <li>
                Added unofficial ice butterfly set, big thanks to Snow + Shrine!
                <ul
                  style={{
                    width: "50%",
                  }}
                >
                  <li>Icy Butterflies</li>
                  <li>Ice Butterfly Headpiece</li>
                  <li>Ice Butterfly Dress</li>
                  <li>Ice Butterfly Sparkles</li>
                  <li>Ice Butterfly Hand</li>
                </ul>
              </li>
              <li>
                some images were broken?! fixed weird filenames. if some of your
                saved outfits broke because they included items with a % in the
                name, just look for the corresponding item without the symbol in
                the name!
              </li>
              <li>
                im a backend dev i have like 0 eye for design lol if you have
                any ideas for improvements, my dms are open as always!
              </li>
            </ul>
          </p>
        </div>
        <button
          onClick={onClose}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            background: "#f3f4f6",
            border: "1px solid #ccc",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

const ModalWithText = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div
      style={{
        textAlign: "center",
        margin: "10px",
      }}
    >
      <p>
        <b>
          <span
            onClick={handleModalToggle}
            style={{
              color: "#2563eb",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Info/Changelog
          </span>
        </b>
      </p>

      <Modal isOpen={isModalOpen} onClose={handleModalToggle} />
    </div>
  );
};

export default ModalWithText;
